export default {

  // return an api url (appends parentId if set)
  apiUrl: state => (type) => {
    let url = state[type];
    if (state.parentId) {
      url += `/${state.parentId}`;
    }
    return url;
  },

  // get data which will be saved in the URL
  // AND sent to the server
  urlData: state => {
    const urlData = {
      q: state.q,
      Tag: state.Tag,
      SortOrder: state.SortOrder,
      Take: state.Take
    };

    // add filters
    state.filters.forEach(filter => {
      const filterValues = filter.children
        .filter(item => item.selected);

      // if a filter has selected items, add it
      if (filterValues.length) {
        if (filter.type === 'Range') {
          urlData[filter.value] = {
            From: filterValues[0].from,
            To: filterValues[filterValues.length - 1].to
          };
        } else {
          urlData[filter.value] = filterValues.map(item => item.value);
        }
      }
    });

    return urlData;
  },

  // get data which will be sent to the server
  // NOT saved in the URL
  serverData: state => {
    const serverData = {
      ShowFilters: state.ShowFilters,
      From: state.From,
      ChildItemsOnly: state.childItemsOnly,
      IsSiteSearch: state.isSiteSearch,
    };
    if (state.parentId) {
      serverData.ParentId = state.parentId;
    }
    return serverData;
  }

};